import { Box, Grid, GridItem, HStack, Text } from '@chakra-ui/react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

import AiAgentAdminNavigation from '../navigation/AiAgentAdminNavigation';
import { AskEddy } from '@/client/components/icons/individual/AskEddy';
import DarkModal from '../../../shared/overlay/DarkModal';
import { useAccessHelper } from '@/client/services/hooks/auth/useAccessHelper';
import { useCheckFeatureFlag } from '@/client/services/hooks/auth/useCheckFeatureFlag';
import { useGetPublicImage } from '@/client/services/hooks/media/useGetPublicImage';
import { useTranslation } from 'react-i18next';
import { HUB_SESSION_BANNER_CSS_VAR } from '@/client/components/shared/messaging/HubSessionBanner';

export default function AiAgentAdminLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAdmin } = useAccessHelper();

  if (!isAdmin()) {
    return <Navigate to="/explore" replace />;
  }

  const eddyEnabled = useCheckFeatureFlag('enable_knowledgebase_ai_eddy_assistant');

  const { getPublicImage } = useGetPublicImage();

  return (
    <Box height={`calc(100vh - 88px - var(${HUB_SESSION_BANNER_CSS_VAR}, 0px))`} backgroundColor="white" overflow="hidden" marginTop={-2}>
      <Grid templateColumns="repeat(12, 1fr)" gap={0} height="full">
        <GridItem
          colSpan={2}
          backgroundColor="neutral.0"
          borderRight="1px solid"
          borderRightColor="neutral.100"
          paddingTop={8}
          height="full"
          overflowY="hidden"
        >
          <HStack spacing={2} paddingX={6} marginBottom={4}>
            <AskEddy boxSize={4} />

            <Text fontSize="14px" fontWeight={600} color="baseBlack">
              {t('aiAgent.experts.agent')}
            </Text>
          </HStack>

          <AiAgentAdminNavigation />
        </GridItem>

        <GridItem colSpan={10} height="100%" overflow="hidden">
          <Outlet />
        </GridItem>
      </Grid>

      <DarkModal
        isOpen={!eddyEnabled}
        onClose={() => {}}
        imageSrc={getPublicImage('continu/app-images/eddy-modal-1.jpg')}
        title={t('admin.aiAgent.tryEddyModal.title')}
        description={t('admin.aiAgent.tryEddyModal.description')}
        submitButton={{
          label: t('admin.aiAgent.tryEddyModal.submitButtonLabel'),
          onClick: () => window.open('https://form.typeform.com/to/lX05D52y', '_blank'),
        }}
        cancelButton={{
          label: t('admin.aiAgent.tryEddyModal.cancelButtonLabel'),
          onClick: () => navigate(-1),
        }}
      />
    </Box>
  );
}
